// extracted by mini-css-extract-plugin
export default {"header":"homepage-masthead-h1-over-image-MastheadH1__header--qSsyp"};